// logoutTrigger.js
import Cookies from 'js-cookie';
import { clearUserDetailsState } from './authSlice';
import { setAlertText, setToast, setSeverity } from './commonComponentSlice';

export const logoutUser = (api) => {
  const { dispatch } = api;

  // Clear cookie
  Cookies.remove('access_token');

  // Reset Redux auth state
  dispatch(clearUserDetailsState());

  // Optional: user feedback
  dispatch(setToast(true));
  dispatch(setAlertText('Session timed out. Please log in again.'));
  dispatch(setSeverity('error'));

  // Navigate to login
  window.location.href = '/login'; // Use react-router if you prefer
};
